/**
 * Industry Swiper Slider
 *
 * Initializes Swiper sliders for industry lists with responsive breakpoints,
 * keyboard navigation, mousewheel support, and custom pagination/navigation.
 *
 * @requires swiper (loaded via CDN in layout)
 */

/**
 * Initialize all Swiper sliders on the page
 */
export function initIndustrySwiper() {
  const swiperSliderGroups = document.querySelectorAll("[data-swiper-group]");

  if (!swiperSliderGroups.length) return;

  // Check if Swiper is available
  if (typeof Swiper === "undefined") {
    console.warn("Swiper is not loaded. Please include the Swiper library.");
    return;
  }

  swiperSliderGroups.forEach((swiperGroup) => {
    const swiperEl = swiperGroup.querySelector("[data-swiper-wrap]");
    if (!swiperEl) return;

    // ✅ Prevent double-init (Swiper attaches the instance to the element)
    if (swiperEl.swiper) return;

    const prevButton = swiperGroup.querySelector("[data-swiper-prev]");
    const nextButton = swiperGroup.querySelector("[data-swiper-next]");
    const pagination = swiperGroup.querySelector(".swiper-pagination");

    // ✅ Avoid initializing a "pagination-less" instance (can cause bullet desync)
    if (!pagination) {
      console.warn(
        "Swiper pagination element not found for group:",
        swiperGroup,
      );
      return;
    }

    // Initialize Swiper
    new Swiper(swiperEl, {
      slidesPerView: 1.25,
      spaceBetween: 20,
      speed: 600,
      // mousewheel: {
      //   forceToAxis: true,
      // },
      grabCursor: true,
      breakpoints: {
        // when window width is >= 480px
        480: {
          slidesPerView: 1.8,
          spaceBetween: 20,
        },
        // when window width is >= 992px
        992: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      pagination: {
        el: pagination,
        type: "bullets",
        clickable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },

      // Optional: Swiper normally updates these automatically.
      // Leave this out unless you have a proven reason to force updates.
      // on: {
      //   activeIndexChange() {
      //     this.pagination?.update();
      //     this.navigation?.update();
      //   },
      // },
    });
  });
}

/**
 * Destroy all Swiper instances
 * Useful for cleanup or re-initialization
 */
export function destroyIndustrySwiper() {
  const swiperSliderGroups = document.querySelectorAll("[data-swiper-group]");

  swiperSliderGroups.forEach((swiperGroup) => {
    const swiperEl = swiperGroup.querySelector("[data-swiper-wrap]");
    if (swiperEl?.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
  });
}

// Auto-initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initIndustrySwiper, {
    once: true,
  });
} else {
  initIndustrySwiper();
}
